import Vue from "vue";
import Vuex from "vuex";

import user from "./user";
import film from "./film";
import horaire from "./horaire";
import site from "./salle";
import tarif from "./tarif";
import prix from "./prix";
import ticket from "./ticket";
import programme from "./programme";
import article from "./article";
import facture from "./facture";
import confiserie from "./confiserie";
import chargement from "./chargement";
import pays from "./pays";
import agregateur from "./agregateur";
import reseau from "./reseau";
import attribut from "./attribut";
import attributsexclure from "./attribut-exclue";
import temoin from "./etat-paiement";
import avis from "./avis";
import permission from "./permission";
import ecran from "./ecran";
import role from "./role";
import flux from "./flux";
import banniere from "./banniere";
import token from "./token";

Vue.use(Vuex);

export default new Vuex.Store({
  strict: true,
  modules: {
    avis,
    user,
    attribut,
    attributsexclure,
    temoin,
    reseau,
    film,
    pays,
    site,
    agregateur,
    horaire,
    prix,
    programme,
    facture,
    article,
    ticket,
    tarif,
    confiserie,
    chargement,
    permission,
    ecran,
    role,
    flux,
    banniere,
    token
  },
});
